// extracted by mini-css-extract-plugin
export var active = "_1p-c";
export var activeIndicator = "_1p-7";
export var animate = "_1p-b";
export var contentWidthTabs = "_1p-5";
export var disabled = "_1p-d";
export var flat = "_1p-1";
export var fullWidth = "_1p-3";
export var lg = "_1p-a";
export var md = "_1p-9";
export var redoButtonTabGroup = "_1p-0";
export var sm = "_1p-8";
export var tabButton = "_1p-4";
export var tabButtonsContainer = "_1p-2";
export var xs = "_1p-6";